import React, { useEffect, useState, useContext, useCallback } from 'react';
import { AppContext } from '../main';
import { Parallax } from "react-parallax";
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Homestatic from '../section-pages/homestatic';
import Marquee from '../section-pages/marquee';
import Pricelist from '../section-pages/pricelist';
import Section1 from '../section-pages/section-1';
import Reviews from '../section-pages/CustomerReviews';
import Collection from '../section-pages/Collection';
import Help from '../section-pages/help';
import Payment from '../section-pages/Payment';
import MenuLinksA from './MenuLinksA';
import MenuLinksB from './MenuLinksB';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import Blog from '../section-pages/Blog-no-title';
import { getDataDB, saveDataDB } from '../api';
import moment from 'moment';
import { MyFileUploader } from '../Components/MyFileUploader';


const image1 = "../../img/background/subheader-news.webp";
const image2 = "./img/background/4.webp";
const image3 = "./img/background/5.webp";

const GlobalStyles = createGlobalStyle`
  .navbar-brand .imginit{
      display: block ;
    }
    .navbar-brand .imgsaly{
      display: none !important;
    }
`;

export default function Home(props) {
  const {
    appState,
    setAppState
  } = useContext(AppContext);
  const {
    editItemMain = {},
    editSection = '',
    editMode = false
  } = appState
  const [modalOpen, setModalOpen] = useState(false);
  const [editItem, setEditItem] = useState({});

  const handleEditClick = (slide) => {
    setEditItem(slide);
    setModalOpen(true);
  };

  const handleSaveConfig = ({
    section,
    config
  }) => {
    // alert(section)
    setAppState((existing) => {
      return {
        ...existing,
        editItemMain: config,
        editSection: section
      };
    });

  };

  const handleSave = useCallback((item) => {
    // alert(JSON.stringify(item))
    if (appState?.[editSection] && Array.isArray(appState?.[editSection])) {
      const index = appState?.[editSection]?.findIndex(res => res.id == item?.id)
      appState[editSection][index >= 0 ? index : appState?.[editSection]?.length + 1] = item
    } else
      if (appState?.[editSection] && typeof appState?.[editSection] == 'object') {
        appState[editSection] = item
      }
    delete appState?.editSection
    delete appState?.section
    delete appState?.editMode

    // console.log('cccccc', appState)
    if (appState)
      saveDataDB({
        query: {
          date: moment(),
          config: appState,
          siteName: 'gamming'
        },
        keys: ['siteName'],
        resource: "vare_sites",
      }).then((info) => {
        setEditItem({})
        setAppState((existing) => {
          return {
            ...existing,
            ...info?.[0]?.config,
            editItemMain: {},
            section: ''
          };
        });
        // console.log('cccccc', info?.[0]?.config,)
      });
  }, [
    editSection
  ]);



  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600)
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600)
    }
  }, []);
  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>HCCC Digital - Game Host</title>
      </Helmet>

      <GlobalStyles />

      {/* LOADER */}
      <div id='mainpreloader'>
        <Preloader />
      </div>

      {/* MENU */}
      {!modalOpen && Object.keys(editItemMain)?.[0]
        ? (
          <EditModal
            item={editItemMain}
            onSave={handleSave}
            onClose={() => {
              setModalOpen(false)
              setEditItem({})
              setAppState((existing) => {
                return {
                  ...existing,
                  editItemMain: {},
                  section: ''
                };
              });
            }}

          />
        )
        :
        <div className="home dark-scheme">
          <header id="header-wrap">
            <Navbar />
          </header>

          {/* Slider */}
          <Parallax className="bgcolor" bgImage={image2} strength={300}>
            <section id="content" className="pt60 no-bottom">
              <Homestatic
                handleEditItem={(e) => handleSaveConfig(e)}
              />
            </section>
          </Parallax>

          {/* Marquee Section */}
          <section className="no-bottom">
            <Marquee handleEditItem={(e) => handleSaveConfig(e)} />
          </section>

          {/* Blog Section */}
          <section>
            <Blog handleEditItem={(e) => handleSaveConfig(e)} />
          </section>

          {/* Pricelist Section */}
          <Parallax className="" bgImage={image3} strength={150}>
            <section className="no-bg pt60 no-bottom">
              <Pricelist handleEditItem={(e) => handleSaveConfig(e)} />
            </section>
          </Parallax>

          {/* Reviews Section */}
          <Parallax className="" bgImage={image3} strength={300}>
            <div className="de-gradient-edge-top"></div>
            <div className="de-gradient-edge-bottom"></div>
            <section className="no-bg no-bottom">
              <Reviews handleEditItem={(e) => handleSaveConfig(e)} />
            </section>
          </Parallax>

          {/* Help Section */}
          <section className="no-bottom">
            <Help handleEditItem={(e) => handleSaveConfig(e)} />
          </section>

          {/* Payment Section */}
          <section>
            <Payment handleEditItem={(e) => handleSaveConfig(e)} />
          </section>

          {/* Menu Links Section A */}
          {/* <section>
          <MenuLinksA
            handleEditItem={(e) => handleSaveConfig(e)}
            data={[
              { title: "Event Calendar", link: "https://tx50010843.schoolwires.net/Page/2" },
              { title: "Parent Portal", link: "https://portals20.ascendertx.com/ParentPortal/login?distid=014801" },
              { title: "Required Postings", link: "https://tx50010843.schoolwires.net/Page/132" },
              { title: "Bully/Incident Reporting System", link: "https://tx50010843.schoolwires.net/domain/49" },
              { title: "Staff Directory", link: "https://tx50010843.schoolwires.net/domain/22" },
              { title: "School Closures", link: "https://tx50010843.schoolwires.net/domain/65" },
              { title: "Enroll Now", link: "https://hros.websmartsolutions.org/S/RichardMilburnAcademy/StandardAdmissionApplication" },
              { title: "Request Transcripts", link: "https://tx50010843.schoolwires.net/Page/69" },
            ]}
          />
        </section> */}

          {/* Menu Links Section B */}
          <section>
            <MenuLinksB
              handleEditItem={(e) => handleSaveConfig(e)}
              data={[
                { title: "London, England", link: "/servers/london" },
                { title: "Paris, France", link: "/servers/paris" },
                { title: "Frankfurt, Germany", link: "/servers/frankfurt" },
                { title: "Amsterdam, Netherlands", link: "/servers/amsterdam" },
                { title: "Stockholm, Sweden", link: "/servers/stockholm" },
                { title: "Helsinki, Finland", link: "/servers/helsinki" },
                { title: "Los Angeles, USA", link: "/servers/los-angeles" },
              ]}
            />
          </section>

          {/* Footer */}
          <Footer />

        </div>}
      <ScrollToTopBtn />
    </>

  )
}



export const EditModal = (props) => {
  const { item, onSave, onClose } = props
  const { appState } = useContext(AppContext);
  const { editSection } = appState;

  const [editedItem, setEditedItem] = useState(item);
  const [imageFiles, setImageFiles] = useState({}); // Stores uploaded image files
  const [refreshing, setRefreshing] = useState(false);
  const [formInput, setFormInput] = useState(false);
  const [uploadNow, setUploadNow] = useState(false);

  // Handle input change for text fields
  const handleInputChange = (key, value) => {
    setEditedItem((prev) => ({ ...prev, [key]: value }));
  };

  // Handle file selection and update state
  const handleFileChange = (key, event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImageFiles((prev) => ({ ...prev, [key]: file })); // Store the file
      setEditedItem((prev) => ({ ...prev, [key]: imageUrl })); // Store preview URL
    }
  };

  // Handle stats update (for array fields)
  const handleStatChange = (index, key, value) => {
    const updatedStats = editedItem.stats.map((stat, i) =>
      i === index ? { ...stat, [key]: value } : stat
    );
    setEditedItem((prev) => ({ ...prev, stats: updatedStats }));
  };

  // Add new stat item
  const addStat = () => {
    setEditedItem((prev) => ({
      ...prev,
      stats: [...prev.stats, { iconClass: "", value: "", label: "", extraClass: "" }],
    }));
  };

  // Remove stat item
  const removeStat = (index) => {
    setEditedItem((prev) => ({
      ...prev,
      stats: prev.stats.filter((_, i) => i !== index),
    }));
  };

  return (
    <div
      style={{
        width: "100%",
        zIndex: 5,
        height: "auto",
        display: "flex",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        padding: 50,
      }}
    >
      <div
        className="modal-content"
        style={{
          width: 500,
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <h2>Edit Item</h2>

        {/* Generate fields dynamically */}
        {Object.keys(editedItem).map((key) => {
          if (key === "id") return null;

          if (key === "image") {
            return (
              <div key={key} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <label>Image</label>
                <input
                  type="text"
                  value={editedItem.image.src}
                  onChange={(e) =>
                    setEditedItem((prev) => ({
                      ...prev,
                      image: { ...prev.image, src: e.target.value },
                    }))
                  }
                  placeholder="Enter image URL"
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileChange("image.src", e)}
                  style={{ display: "none" }}
                  id={`upload-${key}`}
                />
                <label
                  htmlFor={`upload-${key}`}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    padding: "6px 10px",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Upload
                </label>
                <img
                  src={editedItem.image.src}
                  alt={editedItem.image.alt || "Preview"}
                  style={{ maxWidth: "100px", maxHeight: "100px", display: "block", marginTop: 5 }}
                />
                <MyFileUploader
                  {...props}
                  imageKey={"picture"}
                  aiSearchBy={"industry"}
                  resource={"gaming_site_events"}
                  refreshing={refreshing}
                  setRefreshing={setRefreshing}
                  setFormInput={setFormInput}
                  formInput={formInput}
                  uploadNow={uploadNow}
                  allowAdd={false}
                  handleSaveImage={() => setUploadNow(true)}
                />
              </div>
            );
          }

          if (key === "stats" && Array.isArray(editedItem.stats)) {
            return (
              <div key={key} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <label>Stats</label>
                {editedItem.stats.map((stat, index) => (
                  <div key={index} style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    <input
                      type="text"
                      placeholder="Icon Class"
                      value={stat.iconClass}
                      onChange={(e) => handleStatChange(index, "iconClass", e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Value"
                      value={stat.value}
                      onChange={(e) => handleStatChange(index, "value", e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Label"
                      value={stat.label}
                      onChange={(e) => handleStatChange(index, "label", e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Extra Class"
                      value={stat.extraClass}
                      onChange={(e) => handleStatChange(index, "extraClass", e.target.value)}
                    />
                    <button
                      onClick={() => removeStat(index)}
                      style={{ backgroundColor: "red", color: "white", border: "none", padding: "5px 10px" }}
                    >
                      Remove
                    </button>
                  </div>
                ))}
                <button onClick={addStat} className="btn-main">
                  Add Stat
                </button>
              </div>
            );
          }

          return (
            <div key={key} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <label style={{ minWidth: "100px" }}>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
              {key === "description" ? (
                <textarea
                  value={editedItem[key]}
                  onChange={(e) => handleInputChange(key, e.target.value)}
                  rows="4"
                  style={{ flex: 1 }}
                />
              ) : (
                <input
                  type="text"
                  value={editedItem[key]}
                  onChange={(e) => handleInputChange(key, e.target.value)}
                  style={{ flex: 1 }}
                />
              )}
            </div>
          );
        })}

        {/* Buttons */}
        <div style={{ display: "flex", flexDirection: "row", paddingTop: 10, paddingBottom: 10, justifyContent: "center", gap: 20 }}>
          <button
            onClick={() => onSave({ ...editedItem, id: appState?.[editSection]?.length + 1, images: imageFiles })}
            style={{ width: 100 }}
            className="btn-main"
          >
            Save as New
          </button>
          <button onClick={() => onSave(editedItem)} style={{ width: 100 }} className="btn-main">
            Save
          </button>
          <button onClick={onClose} style={{ width: 100 }} className="btn-main">
            Cancel
          </button>
          {item?.id && (
            <button onClick={onClose} style={{ width: 100, backgroundColor: "red", color: "white" }} className="btn">
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};


// export const EditModal = (props) => {
//   const { item, onSave, onClose } = props
//   const { appState } = useContext(AppContext);
//   const { editSection } = appState;

//   const [editedItem, setEditedItem] = useState(item);
//   const [imageFiles, setImageFiles] = useState({}); // Stores uploaded image files
//   const [refreshing, setRefreshing] = useState(false);
//   const [formInput, setFormInput] = useState(false);
//   const [uploadNow, setUploadNow] = useState(false);

//   // Handle input change for text fields
//   const handleInputChange = (key, value) => {
//     setEditedItem((prev) => ({ ...prev, [key]: value }));
//   };

//   // Handle file selection and update state
//   const handleFileChange = (key, event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setImageFiles((prev) => ({ ...prev, [key]: file })); // Store the file
//       setEditedItem((prev) => ({ ...prev, [key]: imageUrl })); // Store preview URL
//     }
//   };

//   // Handle stats update (for arrays)
//   const handleStatChange = (index, key, value) => {
//     const updatedStats = editedItem.stats.map((stat, i) =>
//       i === index ? { ...stat, [key]: value } : stat
//     );
//     setEditedItem((prev) => ({ ...prev, stats: updatedStats }));
//   };

//   // Add new stat item
//   const addStat = () => {
//     setEditedItem((prev) => ({
//       ...prev,
//       stats: [...prev.stats, { iconClass: "", value: "", label: "", extraClass: "" }],
//     }));
//   };

//   // Remove stat item
//   const removeStat = (index) => {
//     setEditedItem((prev) => ({
//       ...prev,
//       stats: prev.stats.filter((_, i) => i !== index),
//     }));
//   };

//   return (
//     <div
//       style={{
//         width: "100%",
//         zIndex: 5,
//         height: 600,
//         overflow: 'auto',
//         display: "flex",
//         position: "relative",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "white",
//         padding: 50,
//       }}
//     >
//       <div
//         className="modal-content"
//         style={{
//           width: 500,
//           display: "flex",
//           flexDirection: "column",
//           gap: 20,
//         }}
//       >
//         <h2>Edit Item</h2>

//         {/* Generate fields dynamically */}
//         {Object.keys(editedItem).map((key) => {
//           if (key === "id") return null;

//           if (key === "image") {
//             return (
//               <div key={key} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//                 <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
//                 <input
//                   type="text"
//                   value={editedItem.image.src}
//                   onChange={(e) =>
//                     setEditedItem((prev) => ({
//                       ...prev,
//                       image: { ...prev.image, src: e.target.value },
//                     }))
//                   }
//                   placeholder="Enter image URL"
//                 />
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) => handleFileChange("image.src", e)}
//                   style={{ display: "none" }}
//                   id={`upload-${key}`}
//                 />
//                 {/* <label
//                   htmlFor={`upload-${key}`}
//                   style={{
//                     cursor: "pointer",
//                     backgroundColor: "#007bff",
//                     color: "#fff",
//                     padding: "6px 10px",
//                     borderRadius: "5px",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Upload
//                 </label> */}
//                 <img
//                   src={editedItem.image.src}
//                   alt={editedItem.image.alt || "Preview"}
//                   style={{ maxWidth: "100px", maxHeight: "100px", display: "block", marginTop: 5 }}
//                 />
//                 <MyFileUploader
//                   {...props}
//                   imageKey={"picture"}
//                   aiSearchBy={"industry"}
//                   resource={"gaming_site_events"}
//                   refreshing={refreshing}
//                   setRefreshing={setRefreshing}
//                   setFormInput={setFormInput}
//                   formInput={formInput}
//                   uploadNow={uploadNow}
//                   allowAdd={false}
//                   handleSaveImage={() => setUploadNow(true)}
//                 />
//               </div>
//             );
//           }

//           if (key === "stats" && Array.isArray(editedItem.stats)) {
//             return (
//               <div key={key} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//                 <label>Stats</label>
//                 {editedItem.stats.map((stat, index) => (
//                   <div key={index} style={{ display: "flex", flexDirection: "column", gap: 5 }}>
//                     <input
//                       type="text"
//                       placeholder="Icon Class"
//                       value={stat.iconClass}
//                       onChange={(e) => handleStatChange(index, "iconClass", e.target.value)}
//                     />
//                     <input
//                       type="text"
//                       placeholder="Value"
//                       value={stat.value}
//                       onChange={(e) => handleStatChange(index, "value", e.target.value)}
//                     />
//                     <input
//                       type="text"
//                       placeholder="Label"
//                       value={stat.label}
//                       onChange={(e) => handleStatChange(index, "label", e.target.value)}
//                     />
//                     <input
//                       type="text"
//                       placeholder="Extra Class"
//                       value={stat.extraClass}
//                       onChange={(e) => handleStatChange(index, "extraClass", e.target.value)}
//                     />
//                     <button
//                       onClick={() => removeStat(index)}
//                       style={{ backgroundColor: "red", color: "white", border: "none", padding: "5px 10px" }}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//                 <button onClick={addStat} className="btn-main">
//                   Add Stat
//                 </button>
//               </div>
//             );
//           }

//           return (
//             <div key={key} style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               <label style={{ minWidth: "100px" }}>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
//               <input
//                 type="text"
//                 value={editedItem[key]}
//                 onChange={(e) => handleInputChange(key, e.target.value)}
//                 style={{ flex: 1 }}
//               />
//             </div>
//           );
//         })}

//         {/* Buttons */}
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             paddingTop: 10,
//             paddingBottom: 10,
//             justifyContent: "center",
//             gap: 20,
//           }}
//         >
//           <button
//             onClick={() =>
//               onSave({
//                 ...editedItem,
//                 id: appState?.[editSection]?.length + 1,
//                 images: imageFiles, // Include uploaded images
//               })
//             }
//             style={{ width: 100 }}
//             className="btn-main"
//           >
//             Save as New
//           </button>
//           <button onClick={() => onSave(editedItem)} style={{ width: 100 }} className="btn-main">
//             Save
//           </button>
//           <button onClick={onClose} style={{ width: 100 }} className="btn-main">
//             Cancel
//           </button>
//           {item?.id && (
//             <button onClick={onClose} style={{ width: 100, backgroundColor: "red", color: "white" }} className="btn">
//               Delete
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };
